<div class="configuration-selection-container">
  <div class="icon-container">
    <nb-icon icon="levels" pack="icomoon"></nb-icon>
  </div>
  <div class="select-menu-container">
    <div class="select-menu-header">
      <h4 class="h4-capitalized">{{ 'view_translations.configuration_url' | translate }}</h4>
      <h4 class="h4-link" (click)="open('view_translations.new_configuration', 'view_translations.url_address', 'add_configuration')">
        {{ 'view_translations.add_new_configuration' | translate }}
      </h4>
    </div>
    <form [formGroup]="configurationSelect" *ngIf="urlConfigs">
      <ng-select
        notFoundText="{{ 'view_translations.no_data' | translate }}"
        [ngClass]="{'error-select': configurationSelect.status === 'INVALID' && submitted }"
        [searchable]="false"
        placeholder="{{ 'view_translations.select_label' | translate }}"
        class="select-menu"
        [items]="urlConfigs"
        bindLabel="name"
        bindValue="id"
        formControlName="selectedConfiguration"
        (open)="changeChevronUp()"
        (close)="changeChevronDown()"
        dropdownPosition="bottom"
        (change)="getData($event)">
      </ng-select>
    </form>
  </div>
</div>
